export default {
  namespaced: true,
  state: {
    chatList:[]
  },
  getters: {},
  mutations: {
    // 设置聊天信息
    SET_CHATLIST(state: any, data: any) {
      state.chatList = data
    },
  },
  actions: {}
}
